"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
const deregistrationReasonEnums_1 = require("../enums/deregistrationReasonEnums");
const getContent_1 = require("../helpers/getContent");
const getContentType_1 = require("../helpers/getContentType");
const getSessionUnregisteredEvent_1 = require("../helpers/getEvent/getSessionUnregisteredEvent");
const getState_1 = require("../helpers/getState");
const entity_1 = require("../type/entity");
function setLastAccessedOn(command, user, state) {
    const { timeStamp, creatorId: actorId } = command;
    const { userId } = user;
    if (actorId === userId) {
        state.lastAccessedOn = timeStamp;
    }
}
function setUnregistrationFieldsInILTState(command, iltState) {
    const { timeStamp } = command;
    iltState.sessionId = null;
    iltState.lastAccessedOn = iltState.updatedAt = timeStamp;
}
function setDeregistrationReasonInSessionState(sessionState, deregistrationReason) {
    if (deregistrationReason) {
        sessionState.deregistrationReason = deregistrationReason;
    }
    else {
        if (sessionState.registerType === entity_1.SessionRegisterType.WAITLISTED) {
            sessionState.deregistrationReason = deregistrationReasonEnums_1.deregistrationReasonEnums.USER_DEREGISTER_FROM_WAITLISTED;
        }
        else {
            sessionState.deregistrationReason = deregistrationReasonEnums_1.deregistrationReasonEnums.USER_DEREGISTER_FROM_REGISTERED;
        }
    }
}
function setUnregistrationFieldsInILTSessionState(command, user, sessionState) {
    const { timeStamp, creatorId: actorId, deregistrationReason } = command;
    setDeregistrationReasonInSessionState(sessionState, deregistrationReason);
    sessionState.deregisteredBy = actorId;
    sessionState.deregisterationTimeStamp = timeStamp;
    sessionState.waitListTimeStamp = null;
    sessionState.registerType = entity_1.SessionRegisterType.NOT_REGISTERED;
    sessionState.updatedAt = timeStamp;
    setLastAccessedOn(command, user, sessionState);
}
function unregisterFromILTSessionState(command, user, content, sessionState) {
    const { contentId, sessionId } = command;
    const { userId, companyId } = user;
    const events = [];
    setUnregistrationFieldsInILTSessionState(command, user, sessionState);
    const currentContent = getContent_1.getContentByContentId(content, contentId);
    const contentType = getContentType_1.getContentType(currentContent);
    const sessionUnregisteredEvent = getSessionUnregisteredEvent_1.getSessionUnregisteredEvent(command, companyId, userId, contentId, contentType, [
        sessionId
    ]);
    events.push(sessionUnregisteredEvent);
    return events;
}
function applyUnregisterILTSessionCommand(command, user, content, states) {
    const { contentId, sessionId } = command;
    const { userId } = user;
    const events = [];
    const updatedStates = immer_1.produce(states, draftStates => {
        // current states
        const iltState = getState_1.getStateByContentIdUserId(draftStates, contentId, userId);
        const sessionState = getState_1.getStateByContentIdUserId(draftStates, sessionId, userId);
        if (sessionState.completionStatus === entity_1.CompletionStatus.COMPLETE) {
            throw new Error('Cannot unregister completed session');
        }
        // unregister from ILT session state
        const sessionStateEvents = unregisterFromILTSessionState(command, user, content, sessionState);
        // set fields in ILT state
        setUnregistrationFieldsInILTState(command, iltState);
        // update events
        events.push(...sessionStateEvents);
    });
    return { states: updatedStates, events, stateInteractions: [], enrolments: [] };
}
exports.applyUnregisterILTSessionCommand = applyUnregisterILTSessionCommand;
//# sourceMappingURL=applyUnregisterILTSessionCommand.js.map